import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import EquipmentStatusChip from '../../EquipmentStatusChip'
import { getHardwareTypeConfig } from '../../hardware-types'

const DetailHeader = ({ equipment, hardwareType, onBack, onPrevious, onNext, hasPrevious, hasNext }) => {
  const { t } = useTranslation()
  const typeConfig = getHardwareTypeConfig(hardwareType)
  const navigationType = t(typeConfig.navigationLabelKey || typeConfig.labelKey)

  return (
    <Stack direction={{ xs: 'column', lg: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', lg: 'center' }} gap={2}>
      <Stack direction="row" alignItems="center" gap={1.5} minWidth={0}>
        <Stack gap={0} minWidth={0}>
          <Typography sx={{ fontSize: 12, lineHeight: '12px', color: '#656565', fontWeight: 400, pl: 4 }}>{t('supervision.title')}</Typography>
          <Stack direction="row" alignItems="center" gap={1} minWidth={0} flexWrap="wrap">
            <Box onClick={onBack} sx={{ width: 24, height: 24, borderRadius: '50%', border: '1px solid #EFEFEF', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#464646', flexShrink: 0 }}>
              <i className="fa-light fa-arrow-left" style={{ fontSize: 12 }} />
            </Box>
            <Typography sx={{ color: '#2570EB', fontSize: 24, fontWeight: 300 }}>{t(typeConfig.labelKey)}</Typography>
            <Typography sx={{ color: '#464646', fontSize: 24, fontWeight: 500, overflowWrap: 'anywhere' }}>{equipment.label}</Typography>
            {equipment.manufacturer?.toLowerCase() !== 'juniper' && <EquipmentStatusChip equipment={equipment} compact />}
          </Stack>
        </Stack>
      </Stack>

      <Stack direction="row" alignItems="center" gap={1} flexShrink={0}>
        <Button onClick={onPrevious} disabled={!hasPrevious} sx={{ height: 32, minHeight: 32, maxHeight: 32, px: 1.5, border: '1px solid #EFEFEF', borderRadius: '999px', color: '#656565', fontSize: 10, fontWeight: 500, textTransform: 'none' }}>
          <i className="fa-light fa-angle-left" style={{ fontSize: 12, marginRight: 6 }} />
          {t('supervision.hardware.detail.previous_by_type', { type: navigationType })}
        </Button>
        <Button onClick={onNext} disabled={!hasNext} sx={{ height: 32, minHeight: 32, maxHeight: 32, px: 1.5, border: '1px solid #EFEFEF', borderRadius: '999px', color: '#656565', fontSize: 10, fontWeight: 500, textTransform: 'none' }}>
          {t('supervision.hardware.detail.next_by_type', { type: navigationType })}
          <i className="fa-light fa-angle-right" style={{ fontSize: 12, marginLeft: 6 }} />
        </Button>
      </Stack>
    </Stack>
  )
}

export default DetailHeader
